import React, { lazy, Suspense, useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import background from '../../../../shared/assets/background.png'
import { LangSwitcher } from '../../../../shared/ui/LangSwitcher/LangSwitcher'
import cls from './HeroSection.module.scss'

const HeroBooking = lazy(() => import('../HeroBooking/HeroBooking'))

const HeroSection: React.FC = () => {
    const { t } = useTranslation()
    const [isBookingOpen, setIsBookingOpen] = useState(false)
    const [showFab, setShowFab] = useState(false)

    const openBooking = useCallback(() => setIsBookingOpen(true), [])
    const closeBooking = useCallback(() => setIsBookingOpen(false), [])

    useEffect(() => {
        const el = document.getElementById('main-hero')
        if (!el) return undefined

        const observer = new IntersectionObserver(
            ([entry]) => {
                setShowFab(!entry.isIntersecting)
            },
            { root: null, threshold: 0.15 }
        )
        observer.observe(el)
        return () => observer.disconnect()
    }, [])

    return (
        <>
            <section
                id="main-hero"
                className={cls.section}
                style={{
                    backgroundImage: `url(${background})`
                }}
            >
                <div className={cls.overlay} />
                <div className={cls.langWrap}>
                    <LangSwitcher style={{ color: '#fff' }} />
                </div>
                <div className={cls.content}>
                    <h1 className={cls.heroTitle}>{t('hero.title')}</h1>
                    <p className={cls.heroSubtitle}>{t('hero.subtitle')}</p>
                    <button
                        type="button"
                        className={cls.primaryCta}
                        onClick={openBooking}
                    >
                        {t('hero.button')}
                    </button>
                </div>
            </section>

            {showFab && !isBookingOpen && (
                <button
                    type="button"
                    className={cls.fab}
                    onClick={openBooking}
                >
                    {t('hero.button')}
                </button>
            )}

            {isBookingOpen && (
                <Suspense fallback={null}>
                    <HeroBooking open={isBookingOpen} onClose={closeBooking} />
                </Suspense>
            )}
        </>
    )
}

export default HeroSection
